import type { AuthUser, Permission, UserType } from '@/types/auth';

/** What a screen or menu item requires. Every listed condition must hold. */
export interface AccessRule {
  /** The user must be one of these types (portal separation). */
  userTypes?: readonly UserType[];
  /** The user must hold every one of these permissions. */
  permissions?: readonly Permission[];
}

/**
 * UI gate only — it hides what the user cannot use. The API enforces the same rules on every
 * request; never rely on this for security.
 */
export function canAccess(user: AuthUser | null, rule: AccessRule = {}): boolean {
  if (!user) return false;
  if (rule.userTypes && !rule.userTypes.includes(user.userType)) return false;
  const granted = new Set(user.permissions);
  return (rule.permissions ?? []).every((p) => granted.has(p));
}
